import { Component, Input } from '@angular/core';

@Component({
    selector: 'c-wizard-header',
    templateUrl: './wizard-header.component.html',
    styleUrls: ['./wizard-header.component.scss'],
    standalone: false
})
export class WizardHeaderComponent {
  @Input() steps = [];
  @Input() activeStep;
  @Input() title: string;
}
